module.exports = function () {

const mobileMenuOpen = () => {
    const hamburger = $('.js-hamburger')
    $(hamburger).on('click', function () {
      $(this).toggleClass('open')
      $('.header-menu').toggleClass('open')
      $('body').toggleClass('overflow-hidden')
    })
    $('.header-menu>li>a').on('click', function () {
      $('.header-menu').removeClass('open')
      $(hamburger).removeClass('open')
      $('body').removeClass('overflow-hidden')
    })
    
}
$(document).ready(() => {
  mobileMenuOpen()
})
};